module.exports = __webpack_public_path__ + "media/newstyle/images/info-orange-28788b74872ba73b611881115f7d3cf2.svg";